import { load3DLogo } from '../../vendor/index.js';

import '../../vendor/jquery.vimeo.api';
import '../../vendor/player';


export default {
  init() {
    this.playPauseVideo();
    /* Script pour le module vidéo avec curseur, preview et ligne élastique */
    $(document).ready(function () {

      $(
        '.module-popup-video .gform-body .gform_page_fields .gform_fields .evenement .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-popup-video .gform-body .gform_page_fields .gform_fields .gfield .ginput_container.ginput_container_checkbox .gfield_checkbox .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-popup-video .gform-body .gform_page_fields .gform_fields .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img'
      ).each(function () {
        import_url_image = $(this).attr('src');
        $(this)
          .parent()
          .css('mask-image', 'url(' + import_url_image + ')');
        $(this)
          .parent()
          .css('background-image', 'none');
      });

      var title_to_dates = ["12/12/2023", "11h30", "11h30"];
      var text_to_placeholder = [];

      $('.module-popup_video .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group .gfield_list_group_item input').addClass('large');

      $('.module-popup_video .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_header .gfield_header_item').each(function (index) {
        text_to_placeholder.push($(this).text());
        $(this).parent().next().find('.gfield_list_group_item').eq(index).find('input').attr('placeholder', title_to_dates[index]);
        $(this).parent().next().find('.gfield_list_group_item').eq(index).find('input').after('<div class="focus-border"></div>');
        $(this).parent().next().find('.gfield_list_group_item').eq(index).find('.focus-border').after('<label class="label">' + title_to_dates[index] + '</label>');

      });

      $(
        '.module-popup_video .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group .gfield_list_group_item input'
      ).each(function () {
        $(this).focusout(function () {
          if ($(this).val() != '') {
            $(this).addClass('has-content');
          } else {
            $(this).removeClass('has-content');
            $(this).val('');
          }
        });
      });

      $(
        '.module-popup_video .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group .gfield_list_group_item input'
      ).each(function () {
        if ($(this).val() != '') {
          $(this).addClass('has-content');
        } else {
          $(this).removeClass('has-content');
          $(this).val('');
        }
      });

      //init 3D logo
      let scene3D;
      var import_url_image;

      MutationObserver =
        window.MutationObserver || window.WebKitMutationObserver;

      var observer = new MutationObserver(function (mutations, observer) {

        $(
          '.module-popup-video .gform-body .gform_page_fields .gform_fields .evenement .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-popup-video .gform-body .gform_page_fields .gform_fields .gfield .ginput_container.ginput_container_checkbox .gfield_checkbox .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-popup-video .gform-body .gform_page_fields .gform_fields .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img'
        ).each(function () {
          import_url_image = $(this).attr('src');
          $(this)
            .parent()
            .css('mask-image', 'url(' + import_url_image + ')');
          $(this)
            .parent()
            .css('background-image', 'none');
        });

      });

      observer.observe(document.getElementsByClassName('module-popup_video')[0], {
        subtree: true,
        attributes: true,
      });


      function openPopup() {
        const logoContainer = $('.wrap_popup .logo_3d_video');

        load3DLogo({ container: logoContainer[0], dark: true }).then((scene) => {
          scene3D = scene;
          scene3D.play();
        });

        $('.module-popup_video').addClass('open');
        $('html').addClass('popup');
        $('.module-popup-video').css({ pointerEvents: 'auto' });
        if ($('.module-popup-video .module-popup_video .popup_content').find('.gform_confirmation_wrapper').length !== 0) {
          $('.module-popup-video .module-popup_video .wrap_popup .logo_3d').css('display', 'block');
        }
        if (scene3D && window.matchMedia('(min-width: 1100px)').matches) {
          scene3D.play();
        }
      }

      $('.iconvideo').on('click', openPopup);

      $('.module-popup_video .close').on('click', function () {
        const formId = document.querySelector('.popup_content').getAttribute('data-formId')

        $('.module-popup_video').removeClass('open');
        $('html').removeClass('popup');
        $('.module-popup-video').css({ pointerEvents: 'none' });

        if (scene3D) {
          scene3D.pause();
        }
      });

      jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        $('.module-popup_video .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group .gfield_list_group_item input').addClass('large');

        var title_to_dates = ["12/12/2023", "11h30", "11h30"];
        var text_to_placeholder = [];
        $('.module-popup_video .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_header .gfield_header_item').each(function (index) {
          text_to_placeholder.push($(this).text());
          $('.module-popup_video .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group').each(function (indexIn) {
            $(this).find('.gfield_list_group_item').eq(indexIn).find('input').attr('placeholder', title_to_dates[index]);
            $(this).find('.gfield_list_group_item').eq(index).find('input').after('<div class="focus-border"></div>');
            $(this).find('.gfield_list_group_item').eq(index).find('.focus-border').after('<label class="label">' + title_to_dates[index] + '</label>');
          });
        });

        $(
          '.module-popup_video .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group .gfield_list_group_item input'
        ).each(function () {
          $(this).focusout(function () {
            if ($(this).val() != '') {
              $(this).addClass('has-content');
            } else {
              $(this).removeClass('has-content');
              $(this).val('');
            }
          });
        });

        $(
          '.module-popup_video .gform_body .gform_page .gform_page_fields .gform_fields .gfield_visibility_visible.dates .ginput_container_list .gfield_list_container .gfield_list_groups .gfield_list_group .gfield_list_group_item input'
        ).each(function () {
          if ($(this).val() != '') {
            $(this).addClass('has-content');
          } else {
            $(this).removeClass('has-content');
            $(this).val('');
          }
        });

        $(
          '.module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last'
        ).each(function () {
          $(this).append('<span class="focus-border"></span>');
        });

        $(
          '.module-popup_video .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input'
        ).each(function () {
          $(this).focusout(function () {
            if ($(this).val() != '') {
              $(this).addClass('has-content');
            } else {
              $(this).removeClass('has-content');
              $(this).val('');
            }
          });
        });

        $(
          '.module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .module-popup_video .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input'
        ).each(function () {
          if ($(this).val() != '') {
            $(this).addClass('has-content');
          } else {
            $(this).removeClass('has-content');
            $(this).val('');
          }
        });

        $(
          '.module-popup_video .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
        ).each(function () {
          $(this).next().append($(this));
        });

        $('.module-popup_video .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible .ginput_container_textarea').append(function () {
          var label_inside = $('.module-popup_video .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible label.gfield_label');
          return label_inside;
        });

      });
    });
  },

  playPauseVideo() {
    $('.video_calculateur').on("click", function () {
      const iframe = $(this).find('iframe')[0]
      let videoContentPlayer = new Vimeo.Player(iframe);

      $(this).toggleClass("noplayed");

      if ($(this).hasClass("noplayed")) {
        videoContentPlayer.play();
        videoContentPlayer.setVolume(1);

      } else {
        videoContentPlayer.pause();
      }
    });
  },
};



